import Api from "utils/api";
import { decryptJSON } from "global/security";

export async function getWorkspaceOverview() {
  const { response, error } = await Api("/super_admin_v2/workspace-overview", "get");

  if (error) {
    throw new Error(error?.message || "Failed to load workspace overview");
  }

  if (!response?.success || !response?.data) {
    throw new Error("Workspace overview is unavailable");
  }

  const data = decryptJSON(response.data);
  return data || {};
}
